var React = require('react');

function Stop (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"4","height":"19","rx":"2","fill":"black","key":0}),React.createElement("rect",{"x":"7","width":"4","height":"19","rx":"2","fill":"black","key":1})]);
}

Stop.defaultProps = {"width":"11","height":"19","viewBox":"0 0 11 19"};

module.exports = Stop;

Stop.default = Stop;
